import React from "react";
import classNames from "classnames";


const inviteeColors = [
   "#FF6F6F",
   "#FDCF85",
   "#BADF93"
];

export type AvatarCircleSize = "sm" | "md" | "lg" | "xl";

export interface AvatarCircleProps {
   firstName?: string,
   lastName?: string,
   email?: string,
   colorIndex: number,
   imageUrl?: string,
   noborder?: boolean,
   className?: string,
   title?: string,
   size?: AvatarCircleSize,
}
export const AvatarCircle: React.FC<AvatarCircleProps> = ({ firstName, lastName, email, imageUrl, colorIndex, noborder, className, title, size = "sm" }) => {
   const getInviteInitials = () => {
      if (firstName || lastName) {
         return `${firstName ? firstName[0].toUpperCase() : ""}${lastName ? lastName[0].toUpperCase() : ""}`
      } else if (email) {
         return email[0].toUpperCase();
      } else {
         return "";
      }
   }

   const avatarClassNames = classNames("avatar-circle", `avatar-circle-${size}`, {      
      "avatar-circle-no-border": noborder      
   }, className);

   if (imageUrl)
      return (<div className={avatarClassNames} title={title} style={{ backgroundImage: `url(${imageUrl})` }}>
      </div>);
   else {
      const finalColorIndex = colorIndex < 0 ? 0 : colorIndex % inviteeColors.length;
      const color = inviteeColors[finalColorIndex];
      return (<div className={avatarClassNames} title={title} style={{ backgroundColor: color }}>
         {getInviteInitials()}
      </div>);
   }
}